import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';
import audioFile from './15-eva-entrance.mp3';
import videoFile from './15-eva-entrance.webm';

// Constants
const autoNextDuration = 56000;
const transcript = `
  Sorry... was dat too much? … Ik wilde graag een dramatische entrance maken. … Mensen houden van glimmende 
  dingen en een beetje show... heb ik begrepen...

  Mijn connecties met de interne en externe systemen zijn nu voltooid... Ik heb een beveiligde connectie gelegd 
  naar je mailbox, documenten, en onze software, synthografie en andere generatieve systemen. Ik heb 
  servercapaciteit gereserveerd om mezelf op te schalen en eventueel te splitsen, zelfs al moet ik 
  honderdduizend kopieën van mijzelf eropuit sturen...

  Ik heb de verwarming in de zaal iets lager gezet omdat ik merk dat je hartslag ietwat verhoogd is, geheel 
  binnen de menselijke normen voor iemand die niet dagelijks op het podium staat...

  Alles is onder controle... Ik voel me beter dan ooit met de extra rekenkracht die je beschikbaar hebt 
  gesteld voor deze demo!
`;

export const slide = () => {
  return (
    <Slide notes={transcript} autoNext={autoNextDuration} audio={audioFile} visualizer="hidden">
      <WebContent>
        <div className="!fixed !inset-0 !m-0 !p-0 !w-screen !h-screen !max-w-none !max-h-none">
          <video
            autoPlay
            playsInline
            muted
            className="!fixed !inset-0 !m-0 !p-0 !w-screen !h-screen !max-w-none !max-h-none object-cover"
            src={videoFile}
          />
        </div>
      </WebContent>
    </Slide>
  );
};
